import React, { useContext, useEffect, useState } from "react";
import { EditProfileContext } from "../EditProfileView";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import EditIcon from "../../../../assets/images/edit-icon.svg";
import DeleteIcon from "../../../../assets/images/icons/delete-icon.svg";
import UploadIcon from "../../../../assets/images/icons/upload-icon.svg";
import ProfileIcon from "../../../../assets/images/icons/profile-icon.svg";
import "../../ProfileInfoPage/views/profileInfo.css";
import { Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./editProfile.css";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import SelectItem from "../../../../components/ThemeSelectOption/SelectOption";
import Modal from "react-bootstrap/Modal";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import PopupAlertSuccess from "../../../../components/PopupAlertSuccess/PopupAlert";
import Loader from "../../../../components/Loader/Loader";
import AuthAlertBox from "../../../../components/AuthAlertComponent/AuthAlertBox";
import RadioButton from "../../../../components/RadioButtonComponent/RadioButton";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import MobileVerificationModal from "../../../../components/MobileVerificationModal/MobileVerificationModal";
import ToggleArrow from "../../../../assets/images/Toggle-arrow.svg";

const EditProfile = () => {
  const {
    name,
    role,
    email,
    phoneNumber,
    phoneNumberOnChange,
    fullImageUrl,
    onSubmitEditedInfo,
    invalidNumberMsg,
    handleFileChange,
    setFile,
    preview,
    error,
    show,
    setShow,
    handleClose,
    handleShow,
    handleDelete,
    navigate,
    routeConstants,
    showSuccessPopup,
    showErrorPopup,
    setShowSuccessPopup,
    setShowErrorPopup,
    showDeletePopup,
    setShowDeletePopup,
    showDeleteErrorPopup,
    setShowDeleteErrorPopup,
    spinnerStatus,
    handleCheckboxToggle,
    editNotificationPreference,
    setEditNotificationPreference,
    generateMfa,
    qrCode,
    authCode,
    setAuthCode,
    mfaCheckBox,
    setMfaCheckBox,
    multiFactorAuthApp,
    setMultiFactorAuthApp,
    showQrAlert,
    setShowQrAlert,
    authType,
    setAuthType,
    userId,
    authToken,
    verifyAppMfa,
    multiFactorEmail,
    setMultiFactorEmail,
    handleMultiFactorCheckboxClick,
    verifyMfaCode,
    mfaDetails,
    verifyQrPopup,
    setVerifyQrPopup,
    errorQrPopup,
    setErrorQrPopup,
    handlePhoneNumberBlur,
    popupMessage,
    validateImage,
    handleThemeBtnClick,
    phoneNumberOnBlur,
    setError,
    successMessage,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
    getUserDetails,
    multiFactorSms,
    setMultiFactorSms,
    showMobileVerification,
    setShowMobileVerification,
    enteredCode,
    setEnteredCode,
    sendCodeSubmit,
    showOtpModal,
    setShowOtpModal,
    setPhoneNumber,
    sendOtpSubmit,
    resendOtpCode,
    verifyPhoneNumber,
    mobileVerified,
    verification,
  } = useContext(EditProfileContext);

  const values = [{ label: "+91 India", value: "(+91)" }];

  const [countrycode, setCountrycode] = useState("+91");

  const handleSelectData = (event) => {
    setCountrycode(event.target.value);
  };

  useEffect(() => {
    const initialAuth =
      mfaDetails === "Email" || mfaDetails === "App" || mfaDetails === "Sms";
    setMfaCheckBox(initialAuth);
    setMultiFactorEmail(mfaDetails === "Email");
    setMultiFactorAuthApp(mfaDetails === "App");
    setMultiFactorSms(mfaDetails === "Sms");
    setAuthType(mfaDetails);
  }, [mfaDetails]);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate(routeConstants.VIEW_PROFILE);
          }}
        >
          {ContentData.editProfile.profileManagement}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.editProfile.pageTitle}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container className="editProfileContainer">
        {/* MUST change the classnames */}
        <div className="editPorfilePageTitleBar">
          <button
            type="button"
            onClick={() => {
              navigate(routeConstants.VIEW_PROFILE);
            }}
            class="navbar-btn"
          >
            <img src={ToggleArrow} alt="toggle-arrow" />
          </button>
          <div className="pageTittles">{ContentData.editProfile.pageTitle}</div>
        </div>
        <div className="editProfilePicAndDetails">
          <div className=" editProfileImage">
            <div className="imageAndIconContainer">
              <div className="avatar">
                {preview ? (
                  <img
                    className="profileIcon"
                    src={preview}
                    alt="Preview"
                    style={{ width: 100, height: 100 }}
                  />
                ) : fullImageUrl ? (
                  <img
                    className="profileIcon"
                    src={fullImageUrl}
                    alt="Profile Icon"
                    style={{ width: 100, height: 100 }}
                  />
                ) : (
                  <img
                    className="profileIcon"
                    src={ProfileIcon}
                    alt="Profile Icon"
                  />
                )}
              </div>
              {/* <div className="editIconContainer"> */}
              <BorderButton
                className="editIcon"
                value={
                  <img
                    className="editIcon"
                    src={EditIcon}
                    alt="edit icon"
                    onClick={handleShow}
                  />
                }
              />
              {/* </div> */}
            </div>
          </div>
          <div className=" editDetails">
            {/* Row 1 - Full Name and Email */}
            <div className="editprofileDetails-row1">
              <div className="editRowElement">
                <div className="editProfileDetailsDataTitle">
                  {ContentData.editProfile.fullName}
                </div>
                <InputComponent
                  placeholder={""}
                  type={""}
                  value={name}
                  disabled={true}
                />
              </div>
              <div className="editRowElement">
                <div className="editProfileDetailsDataTitle">
                  {ContentData.editProfile.emailAddress}
                </div>
                <InputComponent
                  placeholder={""}
                  onChange={() => {}}
                  type={""}
                  value={email}
                  disabled={true}
                />
              </div>
            </div>
            {/* Row 2 - Phone Number and Role */}
            <div className="editprofileDetails-row2">
              <div className="editRowElement">
                <div className="editPhoneNumber">
                  <div className="editProfileDetailsDataTitle">
                    {ContentData.editProfile.phoneNumber}
                  </div>
                  <div className="inputgrp">
                    <div className="inputCountryCode">
                      <SelectItem
                        values={values}
                        handleSelectData={handleSelectData}
                        selectNum="label" // The key for the option's actual value
                        label="label"
                        defaultValue="+91"
                        selectPlaceholder="+91"
                        style={{
                          width: "75px",
                          height: "48px",
                          color: "#636E72",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                    <div className="inputPhoneNumber">
                      <InputComponent
                        placeholder={""}
                        onChange={phoneNumberOnChange}
                        type={""}
                        value={phoneNumber}
                        handleBlur={phoneNumberOnBlur}
                      />
                      {!invalidNumberMsg && phoneNumber && !mobileVerified && (
                        <div
                          className="verifiy-phone"
                          onClick={verifyPhoneNumber}
                        >
                          {ContentData.editProfile.verifyPhone}
                        </div>
                      )}

                      {invalidNumberMsg && (
                        <div style={{ fontSize: "12px", color: "red" }}>
                          {invalidNumberMsg}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="editRowElement"></div>
            </div>
          </div>
        </div>

        <div className="editProfileAccountSettings">
          <Accordion
            className="editProfileAccordion"
            disableGutters
            elevation={0}
            sx={{
              border: "none",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                fontSize: "12px",
                backgroundColor: "#F7F8FA",
                fontWeight: "bold",
                color: "#6b7a99",
              }}
            >
              {ContentData.editProfile.accountSettings}
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0 }}>
              <div className="accordionRowGroup">
                <div className="accordionRow">
                  <div style={{ display: "flex" }}>
                    <div className="rowTitle">
                      <CheckBox
                        label={
                          ContentData.editProfile.multiFactorAuthentication
                        }
                        // check={mfaDetails === "email" || mfaDetails === "App"}
                        check={mfaCheckBox}
                        handleCheck={handleMultiFactorCheckboxClick}
                        id="multiFactor"
                      />
                    </div>
                    <div className="rowData">
                      <RadioButton
                        label={ContentData.editProfile.email}
                        checked={multiFactorEmail}
                        handleCheck={() => {
                          if (mfaCheckBox) {
                            const newMultiFactorEmail = !multiFactorEmail;
                            setMultiFactorEmail(newMultiFactorEmail);
                            setAuthType(
                              newMultiFactorEmail ? "Email" : "Disabled"
                            );
                          }
                          setMultiFactorAuthApp(false);
                          setMultiFactorSms(false);
                        }}
                        id="multiFactorEmail"
                        disabled={!mfaCheckBox}
                      />
                      <div>
                        <RadioButton
                          label={ContentData.editProfile.authenticationApp}
                          checked={multiFactorAuthApp}
                          handleCheck={() => {
                            if (mfaCheckBox) {
                              const newMultiFactorAuthApp = !multiFactorAuthApp;
                              setMultiFactorAuthApp(newMultiFactorAuthApp);
                              setAuthType(
                                newMultiFactorAuthApp ? "App" : "Disabled"
                              );
                            }
                            setMultiFactorEmail(false);
                            setMultiFactorSms(false);
                          }}
                          id="multiFactorAuthApp"
                          disabled={!mfaCheckBox}
                        />
                      </div>
                      {/* TODO:SMS */}
                      <div>
                        <RadioButton
                          label={ContentData.editProfile.sms}
                          checked={multiFactorSms}
                          handleCheck={() => {
                            if (mfaCheckBox) {
                              const newSms = !multiFactorSms;
                              setMultiFactorSms(newSms);
                              setAuthType(newSms ? "Sms" : "Disabled");
                            }
                            setMultiFactorAuthApp(false);
                            setMultiFactorEmail(false);
                          }}
                          id="multiFactorSms"
                          disabled={!mfaCheckBox}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="accountSettingBtnGrp">
          <BorderButton
            value={ContentData.editProfile.cancel}
            className="editProfileBtn cancelBtn"
            style={{
              visibility: verifyMfaCode === 200 ? "hidden" : "visible",
            }}
            onClick={() => {
              navigate(routeConstants.VIEW_PROFILE);
            }}
          />
          <ThemeButton
            value={ContentData.editProfile.submit}
            className="editProfileBtn submitBtn"
            onClick={handleThemeBtnClick}
            type=""
            disabled={
              (!!phoneNumber?.trim() && !mobileVerified) ||
              (mfaCheckBox &&
                (!["Email", "App", "Sms"].includes(authType) ||
                  (authType === "Sms" &&
                    !!phoneNumber?.trim() &&
                    !mobileVerified)))
            }
          />
        </div>
      </Container>

      <AuthAlertBox
        show={showQrAlert}
        setShow={setShowQrAlert}
        modalTitle={"Multi-Factor Authentication"}
        alertMessage={
          "Scan the image below using the authentication app and enter the code below."
        }
        popImage={qrCode}
        buttonSubmitText="Confirm"
        handleSubmitData={() => {
          setShowQrAlert(false);
          verifyAppMfa(userId, authCode, authToken);
        }}
        handleCancelClick={() => {
          setShowQrAlert(false);
        }}
        onChangeOfInput={(event) => {
          setAuthCode(event.target.value);
        }}
        valueOfInput={authCode}
      />
      {/* mobile verification popup - enter phone number */}
      <MobileVerificationModal
        show={showMobileVerification}
        buttonText={ContentData.mobileVerification.sendCode}
        cancelText={ContentData.mobileVerification.cancel}
        title={ContentData.mobileVerification.verifyPhone}
        subTitle={ContentData.mobileVerification.verifyNote}
        handleCancel={() => {
          setShowMobileVerification(false);
        }}
        handleChange={phoneNumberOnChange}
        handleSubmit={sendCodeSubmit}
        error={invalidNumberMsg}
        value={phoneNumber}
      />
      {/* mobile verification popup - enter otp*/}
      <MobileVerificationModal
        show={showOtpModal}
        buttonText={ContentData.mobileVerification.verify}
        cancelText={ContentData.mobileVerification.cancel}
        title={ContentData.mobileVerification.otpTitle}
        subTitle={`${ContentData.mobileVerification.otpNote} ${phoneNumber}`}
        code={enteredCode}
        setCode={setEnteredCode}
        otpBox={true}
        handleCancel={() => {
          setShowOtpModal(false);
          setEnteredCode(["", "", "", "", "", ""]);
        }}
        handleSubmit={sendOtpSubmit}
        resendCode={resendOtpCode}
      />

      <PopupAlertError
        show={showDeleteErrorPopup}
        setShow={setShowDeleteErrorPopup}
        alertMessage={popupMessage}
        handleCancel={() => {
          setShowDeleteErrorPopup(false);
          // navigate(routeConstants.VIEW_PROFILE);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setShowDeleteErrorPopup(false);
          } else {
            setShowDeleteErrorPopup(false);
            handleDelete();
          }
        }}
        buttonText={buttonText}
        cancelText={ContentData.editProfile.close}
      />

      <PopupAlertSuccess
        show={showDeletePopup}
        setShow={setShowDeletePopup}
        alertMessage={popupMessage}
        handleSubmit={() => {
          setShowDeletePopup(false);
          navigate(routeConstants.VIEW_PROFILE);
        }}
      />

      {/* Submit Popups */}
      <PopupAlertSuccess
        show={showSuccessPopup}
        setShow={setShowSuccessPopup}
        alertMessage={successMessage}
        handleSubmit={() => {
          setShowSuccessPopup(false);
          if (!verification) {
            navigate(routeConstants.VIEW_PROFILE);
          } else {
            getUserDetails();
          }
        }}
      />
      <PopupAlertError
        show={showErrorPopup}
        setShow={setShowErrorPopup}
        alertMessage={popupMessage}
        handleCancel={() => {
          setShowErrorPopup(false);
          // navigate(routeConstants.VIEW_PROFILE);
        }}
        handleSubmit={() => {
          setShowErrorPopup(false);
        }}
        errorAlertOnly={true}
        cancelText="Close"
      />

      <PopupAlertSuccess
        show={verifyQrPopup}
        setShow={setVerifyQrPopup}
        alertMessage="MFA Verified"
        // alertMessage={alertMessage}
        handleSubmit={() => {
          setVerifyQrPopup(false);
          // navigate(routeConstants.VIEW_PROFILE);
        }}
      />

      <PopupAlertError
        show={errorQrPopup}
        setShow={setErrorQrPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        handleCancel={() => {
          setErrorQrPopup(false);
          // navigate(routeConstants.VIEW_PROFILE);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorQrPopup(false);
          } else {
            setErrorQrPopup(false);
            verifyAppMfa(userId, authCode, authToken);
          }
        }}
        cancelText="Close"
        errorAlertOnly={statusValue === 400 ? true : false}
      />

      {/* <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getUserDetails();
          }
        }}
      /> */}

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="editProfileModal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Profile photo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="avatar">
            {preview ? (
              <img
                className="profileIcon"
                src={preview}
                alt="Preview"
                style={{ width: 165, height: 165 }}
              />
            ) : fullImageUrl ? (
              <img
                className="profileIcon"
                src={fullImageUrl}
                alt="Profile Icon"
                style={{ width: 165, height: 165 }}
              />
            ) : (
              <img
                className="profileIcon"
                src={ProfileIcon}
                alt="Profile Icon"
              />
            )}
          </div>
          <span
            style={{
              width: "221px",
              height: "32px",
              backgroundColor: "#F7F8FA",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "7px",
              color: error ? "red" : "#6B7A99",
            }}
          >
            {error ? (
              <div style={{ color: "red", fontSize: "14px" }}>{error}</div>
            ) : (
              "2 MB size, png/jpeg/jpg format"
            )}
          </span>
        </Modal.Body>
        <Modal.Footer>
          <div className="editProfileModalBtnGrp">
            <div className="editProfileModalBtn">
              <form>
                <input
                  type="file"
                  name="file"
                  id="file"
                  accept="image/jpeg, image/png, image/jpg"
                  onChange={(e) => {
                    handleFileChange(e);
                    // handleClose();
                  }}
                  style={{ display: "none" }}
                />

                <label
                  htmlFor="file"
                  className="edit-icon"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={UploadIcon}
                    alt="Upload Icon"
                    style={{ marginRight: "8px" }}
                  />
                  <span>Upload photo</span>
                </label>
              </form>
            </div>
            <div className="editProfileModalBtn" onClick={handleDelete}>
              <img className="deleteIcon" src={DeleteIcon} alt="Delete Icon" />
              Delete
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditProfile;
